import EnvironmentVariable from '../../../types/BotBuilder/EnvironmentVariable';

const KEY_PATTERN = /^[a-zA-Z]\w*$/;

export function validateEnvironmentVariableKey(key: string): string | null {
  if (!key) return 'Key is required';
  if (key.length < 2) return 'Key must be at least 2 characters';
  if (!KEY_PATTERN.test(key)) {
    return 'Key must start with a letter and contain only letters, numbers, and underscores';
  }
  return null;
}

export function validateEnvironmentVariableValue(value: string): string | null {
  if (!value) return 'Value is required';
  return null;
}

export function validateEnvironmentVariables(
  variables: EnvironmentVariable[]
): string[] {
  const errors: string[] = [];

  variables.forEach((envVar) => {
    const keyError = validateEnvironmentVariableKey(envVar.key);
    if (keyError) {
      errors.push(`Environment variable: ${keyError}`);
    }

    const valueError = validateEnvironmentVariableValue(envVar.value);
    if (valueError) {
      errors.push(
        `Environment variable "${envVar.key || '(unnamed)'}": ${valueError}`
      );
    }
  });

  return errors;
}
